import { Button } from '../Button'

interface NavigationButtonsProps {
  currentStep: number
  totalSteps: number
  resumeUploading: boolean
  saving: boolean
  aiMemoryUploading: boolean
  handleBackWrapper: () => void
  handleSkip: () => void
  handleNext: () => void
}

export function NavigationButtons({
  currentStep,
  totalSteps,
  resumeUploading,
  saving,
  aiMemoryUploading,
  handleBackWrapper,
  handleSkip,
  handleNext,
}: NavigationButtonsProps) {
  const finishing = currentStep >= totalSteps
  const nextDisabled = finishing
    ? saving || aiMemoryUploading
    : currentStep === 2 && resumeUploading

  return (
    <div className="mt-8 flex justify-between">
      <div>
        {currentStep > 1 && (
          <Button type="button" variant="secondary" onClick={handleBackWrapper}>
            Back
          </Button>
        )}
      </div>

      <div className="flex gap-2">
        <Button type="button" variant="ghost" onClick={handleSkip}>
          Skip for now
        </Button>
        <Button
          type="button"
          variant="primary"
          onClick={handleNext}
          disabled={nextDisabled}
          loading={finishing && saving}
          loadingLabel="Saving..."
        >
          {finishing ? 'Complete' : 'Next'}
        </Button>
      </div>
    </div>
  )
}
